// extracted by mini-css-extract-plugin
export default {"heading":"Insights_heading__jMoT1","product-button":"Insights_product-button__xbQts","form":"Insights_form__tHffo","form__buttons":"Insights_form__buttons__RpEpU"};